var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5675 12.1829C12.6256 12.241 12.6717 12.3099 12.7031 12.3858C12.7345 12.4617 12.7507 12.543 12.7507 12.6251C12.7507 12.7072 12.7345 12.7885 12.7031 12.8644C12.6717 12.9403 12.6256 13.0092 12.5675 13.0673C12.5095 13.1254 12.4405 13.1714 12.3647 13.2028C12.2888 13.2343 12.2075 13.2505 12.1253 13.2505C12.0432 13.2505 11.9619 13.2343 11.886 13.2028C11.8102 13.1714 11.7412 13.1254 11.6832 13.0673L6.50035 7.8837L1.31753 13.0673C1.20026 13.1846 1.0412 13.2505 0.875347 13.2505C0.709495 13.2505 0.550435 13.1846 0.43316 13.0673C0.315885 12.95 0.25 12.791 0.25 12.6251C0.25 12.4593 0.315885 12.3002 0.43316 12.1829L5.61675 7.0001L0.43316 1.81729C0.315885 1.70002 0.25 1.54096 0.25 1.3751C0.25 1.20925 0.315885 1.05019 0.43316 0.932916C0.550435 0.81564 0.709495 0.749756 0.875347 0.749756C1.0412 0.749756 1.20026 0.81564 1.31753 0.932916L6.50035 6.11651L11.6832 0.932916C11.8004 0.81564 11.9595 0.749756 12.1253 0.749756C12.2912 0.749756 12.4503 0.81564 12.5675 0.932916C12.6848 1.05019 12.7507 1.20925 12.7507 1.3751C12.7507 1.54096 12.6848 1.70002 12.5675 1.81729L7.38394 7.0001L12.5675 12.1829Z",
    fill: "#24313E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelX);
export default __webpack_public_path__ + "static/media/cancel-x.ce4510aea1e963bb22092bf370bb96b6.svg";
export { ForwardRef as ReactComponent };